import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["focus"];

  focus() {
    this.focusTarget.focus();
  }

  focusChecked() {
    this.element.querySelector("input:checked").focus();
  }

  blur() {
    this.focusTarget.blur();
  }
}
